import { SizeBucket, sizeBucketLabelMap } from '../SizeBucket';

export const useOrderedSizeBuckets = (sizeBuckets: SizeBucket[]) => {
  return Object.keys(sizeBucketLabelMap).filter((sizeBucket) =>
    sizeBuckets.includes(sizeBucket)
  );
};
